import React from "react";
import { Button as ButtonAntd, Checkbox, Popconfirm } from "antd";
import { CheckboxChangeEvent } from "antd/es/checkbox";
import { MinusCircleTwoTone, SelectOutlined } from "@ant-design/icons";
import { ControlPointItem } from "../../../types/interfaces";

const ValidationTableColumns = (
    deleteHandler: (index: string) => void,
    showHandler: (index: string, show: boolean) => void,
    selectTieHandler: (index: string) => void,
    changeTitle: (index: string, e: any) => void
) => {
    const result = [
        {
            title: "",
            key: "show",
            width: 35,
            render: (item: any, record: ControlPointItem) => {
                const showConfirm = (e: CheckboxChangeEvent) => {
                    showHandler(record.no, e.target.checked);
                };

                return <Checkbox checked={record.show} onChange={showConfirm} />;
            }
        },
        {
            title: "Title",
            dataIndex: "title",
            key: "title",
            align: "left",
            width: 200,
            render: (item: any, record: ControlPointItem) => (
                <input name="title" defaultValue={record.title} onBlur={(e) => changeTitle(record.no, e)} />
            )
        },
        {
            title: "X",
            dataIndex: "x",
            key: "x",
            align: "left",
            width: 100
        },
        {
            title: "Y",
            dataIndex: "y",
            key: "y",
            align: "left",
            width: 100
        },
        {
            title: "Z",
            dataIndex: "z",
            key: "z",
            align: "left",
            width: 100
        },
        {
            title: "Action",
            key: "operation",
            fixed: "right",
            width: 90,
            render: (item: any, record: ControlPointItem) => (
                <div>
                    <Popconfirm
                        placement="topRight"
                        title="Are you sure to delete this item?"
                        onConfirm={() => deleteHandler(record.no)}
                        okText="Yes"
                        cancelText="No"
                    >
                        <ButtonAntd shape="circle" icon={<MinusCircleTwoTone twoToneColor="#ff0000" />} />
                    </Popconfirm>
                    <ButtonAntd shape="circle" onClick={() => selectTieHandler(record.no)} icon={<SelectOutlined />} />
                </div>
            )
        }
    ];
    return result;
};

export default ValidationTableColumns;
